module.exports = __webpack_public_path__ + "img/destombamento.bf8caffc.svg";